import React, { Component } from 'react';
import './ShareDialog.css';


class ShareDialog extends Component {
 
  render() {
    const { display, image, page, callback, desc } = this.props;
    if (display && !image) {
    return (
      <div className="share-dialog">
      <div onClick={this.props.close}  className="close-share-dialog">×</div>
      <div>Please wait while a chart is being generated</div>
      </div>
    )} else if (display && image && page){
      return (<div className="share-dialog">
      <div onClick={this.props.close} className="close-share-dialog">×</div>
        <div>{desc}</div>
        <img className="share-preview" src={image} />
        <div>The image will be visible in your post or tweet even if it does not appear in the preview.</div>
        <button onClick={callback}>Share</button>
      </div>)
    } else {
      return (<div></div>)
    }
  }
}

export default ShareDialog;



// WEBPACK FOOTER //
// ./src/components/ShareDialog/ShareDialog.js